/**
 *
 * DashboardSuggestionsIA
 *
 */


import React, { Fragment } from "react"
import "./index.less"
import { loadTexts, sanitize,getLanguage } from "../../utils/i18n"
import iconVaritaMagica from "images/varita-magica.svg"
import beta from "images/beta.svg"
import { getSuggestionsForAmbassadorDashboard } from "services/actionPlans"
import { Row, Col, Tag } from "antd"
import {
  Spin,
  Select,
  Button
} from "antd"
import { Link } from "react-router-dom"
import ModalActionPlanCreate from "components/ModalActionPlanCreate"
import IconoVaritaMagica from 'components/ModalActionPlanCreate/IconoVaritaMagica.js';


/* eslint-disable react/prefer-stateless-function */
class DashboardSuggestionsIA extends React.Component {


  state = {
    mounted: false,
    selectedDivision: null,
    divisions: [],
    measureName: [],
    dimensions: [],
    plans: [],
    loadingPlans: false,
    modalPreview: false,
    modalPreviewData: [],
    selectedDimensionData: [],
    modalPreviewDataDivision: []
  }

  componentDidMount() {
    this.setState({ mounted: true }, () => {
      const { result_dimensions_ia } = this.props;
      this.initializeComponent(result_dimensions_ia);
    });
  }

  componentWillUnmount() {
    this.setState({ mounted: false });
  }

  initializeComponent = (result_dimensions_ia) => {
    this.setState({
      divisions: result_dimensions_ia.divisions,
      measureName: result_dimensions_ia.measure.name,
      dimensions: result_dimensions_ia.divisions[0].has_dimensions ? result_dimensions_ia.divisions[0].dimensions.filter(item => !item.has_action_plans) : [],
      selectedDivision: result_dimensions_ia.divisions[0]
    }, () => {
      if (this.state.selectedDivision.has_dimensions) {
        this.getSuggestions();
      }
    });
  }

  getSuggestions = async () => {
    try {
      this.setState({ loadingPlans: false });

      const suggestionsIa = await getSuggestionsForAmbassadorDashboard({
        dimensions: this.state.dimensions,
        seccion: this.props.dashboard ? "action_plans" : "dashboard"
      });

      if (this.state.mounted && suggestionsIa.status === 200) {
        this.setState(prevState => ({
          dimensions: prevState.dimensions.map((dimension, index) => {
            const item = suggestionsIa?.data?.data?.result ? suggestionsIa.data.data.result[index] : null;
            if (item) {
              const parsedContentOutput = JSON.parse(item.content_output);
              dimension.parsedContentOutput = parsedContentOutput[item.pdas_counter];
            }
            return dimension;
          }),
          loadingPlans: true,
          modalPreviewData: suggestionsIa.data.data.result
        }));
      }
    } catch (error) {
      console.error("Error al obtener getSuggestions", error);
    }
  }



  onChangeDivision = async (selectedDivision) => {
    const selectDivision = this.state.divisions.find(division => division.id_division === selectedDivision);
    this.setState({ selectedDivision: selectDivision, dimensions: selectDivision.has_dimensions ? selectDivision.dimensions.filter(item => !item.has_action_plans) : [] }, () => {
      this.getSuggestions()
    });
  }




  handleClickPreview(data) {

    const selectedData = this.state.modalPreviewData.find(item => item.id_dimension === data.id_dimension);

    if (selectedData) {
      this.setState({
        modalPreview: true,
        modalPreviewDataDivision: selectedData,
        selectedDimensionData: data
      })
    }
  }

  setStateFrom = (name, value) => {
    this.setState({ [name]: value })
  }



  intl = loadTexts("dashboard")
  render() {
    const {
      divisions,
      measureName,
      dimensions,
      loadingPlans,
      selectedDivision,
      modalPreview,
      modalPreviewDataDivision,
      selectedDimensionData
    } = this.state

    const {
      dashboard
    } = this.props
    return (
      <Fragment>
        {divisions.length > 0 && (

          <div className="DashboardSuggestionsIAComponent"   >
            {

              <div >
                <Row>
                  {!dashboard &&
                    <Col span={3} className="special-col" >
                      <div className="DashboardSuggestions-columns-left-content-block-title">
                        <img width={30} src={iconVaritaMagica} style={{ opacity: 0.8 }} />
                        {this.intl.suggestionsIa.titleOne} <br />
                        {this.intl.suggestionsIa.titleTwo}
                        {getLanguage() == "en" && <br />

                        }
                      </div></Col>}
                  <Col style={dashboard ? { background: "#FFFFFF" } : {}}>

                    {dashboard &&
                      <div className="DashboardSuggestions-especialHeader"  >

                        <div style={{ flex: 1, display: 'flex', alignItems: 'center', marginTop: 5 }}>
                          <span
                            style={{ color: "#55C8AE", fontWeight: 600, marginRight: 8 }}> {this.intl.suggestionsIa.titleIa}</span>  <IconoVaritaMagica fill={"#55C8AE"} /> 
                        </div>
                        <div>
                          <span style={{ color: "#55C8AE" }}> {this.intl.suggestionsIa.descriptionIa}</span>
                        </div>
                      </div>
                    }

                    <div style={dashboard ? { paddingLeft: 20, paddingRight: 20 } : {}}>
                      {divisions.length > 1 && (
                        <div className="DashboardSuggestions-columns-left-content-block-subtitle"
                          style={dashboard ? { fontSize: 13, marginBottom: 4, marginTop: 16 } : { fontSize: 13,marginBottom: 4 }}>

                          {this.intl.suggestionsIa.selectDivision}
                        </div>
                      )}

                      {divisions.length > 1 && (
                        <Select
                          style={{ width: 300 }}
                          id="dropdownDivision"
                          defaultValue={divisions.length > 0 ? divisions[0].id_division : null}
                          onChange={(selectedDivision) => {
                            this.onChangeDivision(selectedDivision)
                          }}>
                          {divisions.map((f, i) => (
                            <Option key={i} value={f.id_division}>
                              {f.division_name}
                            </Option>
                          ))}
                        </Select>
                      )}

                      {!selectedDivision.all_dimensions_have_plans && selectedDivision.has_dimensions && (<div>

                        <div style={{ marginTop: "10px", marginBottom: "10px" }}>

                          <span className="DashboardSuggestions-columns-left-content-block-measure" >{this.intl.suggestionsIa.subTitleMeasureOne} <b>{measureName}</b>{" "} {this.intl.suggestionsIa.subTitleMeasureTwo}</span>
                        </div>
                        <div className="DashboardSuggestions-container">
                          {dimensions.map((item, index) => (
                            <div className="DashboardSuggestions-dimensions" key={index}>
                              {item.dimension_name} <Tag color={item.color}>{item.value}</Tag>
                            </div>
                          ))}
                        </div>
                        <div style={{ marginTop: "10px", marginBottom: "10px" }}>
                          <span className="DashboardSuggestions-columns-left-content-block-measure" >{sanitize(this.intl.suggestionsIa.recommendation)}</span>
                        </div>
                        {!loadingPlans && (

                          <div className="DashboardSuggestions-loader" style={{marginBottom: 10}}>
                            <div className="DashboardSuggestions-loadingSpin">
                              <Spin />
                              <br />
                              <span className="DashboardSuggestions-columns-left-content-block-loaderTitle">{this.intl.suggestionsIa.loader}</span>

                            </div>
                          </div>
                        )}

                        {loadingPlans && dimensions.map((item, key) => (
                          <div className="ActionPlanCard-component" style={{ marginBottom: 10 }} key={key}>
                            <div
                              className="ActionPlanCard-component-row"
                            >

                              <div>
                                <div
                                  className="ActionPlanCard-component-border"
                                  style={{ background: item.color }}
                                />


                                <div className="ActionPlanCard-component-row-header">
                                  <div className="ActionPlanCard-component-row-header-information">
                                    <div className="ActionPlanCard-component-row-header-information-dimensions">


                                      <div key={`dimension-container-${key}`}>
                                        <span key={`dimension-name-action-plan-${key}`}>{item.dimension_name}</span>
                                      </div>
                                    </div>
                                    <div>

                                      <div className="ActionPlanCard-component-row-header-information-title">
                                        {item.parsedContentOutput && (

                                          <span>{item.parsedContentOutput.nombreDePlan}</span>
                                        )}
                                      </div>


                                    </div>
                                    <div> <span className="color-gray-low">
                                      {item.parsedContentOutput && (

                                        <span>{item.parsedContentOutput.acciones.length} {" "}
                                          {this.intl.suggestionsIa.tasks}</span>
                                      )}


                                    </span>


                                    </div>

                                  </div>
                                  <div className="ActionPlanCard-component-row-header-information">
                                    <div className="ActionPlanCard-component-row-header-information-button">    <Button

                                      onClick={() => {
                                        this.handleClickPreview(item)

                                      }}>{this.intl.suggestionsIa.seen}</Button>

                                    </div>

                                  </div>
                                </div>
                              </div>

                            </div>
                          </div>

                        ))}
                      </div>)}
                    </div>
                    {selectedDivision.all_dimensions_have_plans && (<div className="DashboardSuggestions-havePlans">
                      <div className="DashboardSuggestions-havePlans-row">
                        <Col className="DashboardSuggestions-havePlans-row-col">
                          <span className="DashboardSuggestions-havePlans-row-col-title">{this.intl.suggestionsIa.appliedTitle}</span>
                          <span className="DashboardSuggestions-havePlans-row-col-subtitle">{this.intl.suggestionsIa.appliedSubTitleOne}</span>
                          <span className="DashboardSuggestions-havePlans-row-col-subtitle">{this.intl.suggestionsIa.appliedSubTitleTwo}</span>

                        </Col>
                        <Col className="DashboardSuggestions-havePlans-row-col">
                          <div className="DashboardSuggestions-havePlans-row-col-button">
                            <Button >

                              <Link to={"/action-plans"}> {this.intl.suggestionsIa.goToPda}</Link>
                            </Button>

                          </div>
                        </Col>
                      </div>


                    </div>)}



                    {!selectedDivision.has_dimensions && (
                      <div className="DashboardSuggestions-exceedLimit"

                        style={dashboard ? { marginLeft: 22, marginRight: 22, marginBottom: 22 } : {}}>

                        <span>{sanitize(this.intl.suggestionsIa.exceedlimiteOne)}

                          <b>{measureName}</b>{" "}

                          {sanitize(this.intl.suggestionsIa.exceedlimiteTwo)}
                        </span>
                        <span>{sanitize(this.intl.suggestionsIa.exceedlimiteThree)}</span>




                      </div>)}
                  </Col>
                </Row>

                <div>
                </div>

                <ModalActionPlanCreate
                  contentPdaIa={modalPreviewDataDivision}
                  onCancel={() => {
                    this.setState({
                      modalPreview: false,
                      dashboard_enter: false,
                      tasks: [],
                      newTasks: []
                    });
                    if (this.props.setStateFrom) {
                      this.props.setStateFrom("dashboardSuggestionsIAKey", this.props.dashboardSuggestionsIAKey + 1);
                    }
                  }}
                  modalActionPlanCreateIa={true}
                  dashboard_enter={modalPreview}
                  id_dimension={selectedDimensionData.id_dimension}
                  id_measure={selectedDimensionData.id_measure}
                  id_dimension_parent={selectedDimensionData.id_dimension_parent}
                  id_division={selectedDimensionData.id_division}
                  division_name={selectedDimensionData.division_name}
                  dimension_name={selectedDimensionData.dimension_name}
                  dimension_color={selectedDimensionData.color}
                  dimension_value={selectedDimensionData.value}
                  id_company={selectedDimensionData.id_company}
                  id_ambassador={selectedDimensionData.id_ambassador}
                  id_employee={selectedDimensionData.id_employee}
                  dimensions={selectedDimensionData}
                  id_scope_type={selectedDimensionData.id_scope_type}
                  measure_name={selectedDimensionData.measure_name}
                  setStateFrom={this.setStateFrom}
                  finish={() => {
                    this.props.onCreatePlan({})
                    this.props.finish({})
                  }}
                  is_dashboard={!dashboard}
                />


              </div>

            }
          </div>)}
      </Fragment>
    )
  }
}

DashboardSuggestionsIA.defaultProps = {
  dashboard: false,
}
DashboardSuggestionsIA.propTypes = {}

export default DashboardSuggestionsIA
